import {
  ACCOUNTING_MONEY_CONTEXT,
  buildMoneyNotificationBody,
  formatMoney,
  isAccountingNotification,
} from "@reactive-resume/utils";
import { useCallback } from "react";

import { useAccountCurrency } from "@/client/services/currency/currency";

type NotificationText = {
  type: string;
  body?: string | null;
  data?: Record<string, unknown> | null;
};

// Montants recalculés dans la devise actuelle du compte ; devise comptable pour les admins.
export const useNotificationBody = () => {
  const { format } = useAccountCurrency();

  return useCallback(
    (notification: NotificationText) => {
      const formatFcfa = isAccountingNotification(notification.type)
        ? (amount: number) => formatMoney(amount, ACCOUNTING_MONEY_CONTEXT)
        : format;

      return (
        buildMoneyNotificationBody(notification.type, notification.data, formatFcfa) ??
        notification.body ??
        undefined
      );
    },
    [format],
  );
};
